import axios from "axios";
import { withNamespaces } from 'react-i18next';
import React, { useState, useEffect } from 'react';
import { HubConnectionBuilder, JsonHubProtocol } from "@microsoft/signalr";

const StateControllerService = (props) => {

    const [stateController, setStateController] = useState([]);
    const [token] = useState(localStorage.getItem("JWT"));
    const activeRights = JSON.parse(localStorage.getItem("rights"));
    const userCanEdit = activeRights.includes("StateControllerService.Update");
    const link = localStorage.getItem('link')

    let hubConnection = new HubConnectionBuilder()
        .withUrl(link + "/ws/elementHub", {
            accessTokenFactory: () => token,
        })
        .withAutomaticReconnect()
        .withHubProtocol(new JsonHubProtocol())
        .build();

    function loadController() {
        axios
            .get(link + "/api/StateController")
            .then((response) => {
                console.debug("Loaded StateController from API", response.data);
                setStateController(response.data);
            })
            .catch((error) => { console.error(error); });
    }

    function setAreaTriggerValue(controllerId, areaId, value) {
        if (!userCanEdit) {
            return;
        }
        axios
            .put(link + `/api/StateController/SetAreaTriggerValue?controllerId=${parseInt(controllerId)}&areaId=${parseInt(areaId)}&triggerValue=${parseInt(value)}`)
            .catch((error) => { console.error(error); });
    }

    function setAreaTriggerHysteresis(controllerId, areaId, hysteresis) {
        if (!userCanEdit) {
            return;
        }
        axios
            .put(link + `/api/StateController/SetAreaTriggerHysteresis?controllerId=${parseInt(controllerId)}&areaId=${parseInt(areaId)}&hysteresis=${parseFloat(hysteresis.replace(',', '.'))}`)
            .catch((error) => { console.error(error); });
    }

    useEffect(() => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('JWT');
        loadController();

        hubConnection
            .start()
            .then((result) => {
                console.debug("Hub Connection changed %o", result);
                hubConnection.invoke("RegisterStateControllerUpdates");
            });

        console.log("Registering StateControllerChanged WebSocket Hook");
        hubConnection.on("StateControllerChanged", (jsonString) => {
            try {
                let controller = JSON.parse(jsonString);
                let controllerId = controller.id;
                console.debug("Received StateControllerChanged for Controller %s / %i: %o", controller.name, controllerId, controller);

                setStateController(prev =>
                    prev.map(item => item.id === controllerId ? controller : item)
                );
            } catch (error) {
                console.error("Error while processing Controller Changed Event", error);
            }
        });
    }, []);

    const TriggerRows = ({trigger, controllerId}) => {
        const TriggerBase = ({trigger}) => {
            return (
                <>
                    <tr>
                        <td colSpan={2} className="box-name">{props.t("stateControllerService.inputTrigger.inputTrigger")}: {props.t("stateControllerService.inputTrigger." + trigger.$type)}</td>
                    </tr>
                    <tr>
                        <td>{props.t("stateControllerService.activated")}</td>
                        <td>{trigger.active ? props.t("allgemein.ja") : props.t("allgemein.nein")}</td>
                    </tr>
                </>
            )
        }
        
        const LotReservationTrigger = ({trigger}) => {
            return (
                <>
                    <TriggerBase trigger={trigger} />
                    <tr>
                        <td>{props.t("lot.lot")}</td>
                        <td>{trigger.lotName}</td>
                    </tr>
                    <tr>
                        <td>{props.t("stateControllerService.valueNeeded")}</td>
                        <td>{trigger.valueNeeded ? props.t("allgemein.an") : props.t("allgemein.aus")}</td>
                    </tr>
                </>
            )
        }

        const AreaTrigger = ({trigger, controllerId}) => {
            const [hysteresis, setHysteresis] = useState(trigger.hysteresisPercent.toString().replace('.', ','));
            const [triggerValue, setTriggerValue] = useState(trigger.value);
            
            return (
                <>
                    <TriggerBase trigger={trigger} />
                    <tr>
                        <td>{props.t("elementeAllgemein.area")}</td>
                        <td>{trigger.areaName}</td>
                    </tr>
                    <tr>
                        <td>{props.t("stateControllerService.valueField")}</td>
                        <td>{trigger.valueField}</td>
                    </tr>
                    <tr>
                        <td>{props.t("stateControllerService.comparisonMode")}</td>
                        <td>{trigger.comparisonMode}</td>
                    </tr>
                    <tr>
                        <td>{props.t("stateControllerService.valueNeeded")}</td>
                        <td>
                            {userCanEdit ?
                                <>
                                    <input type="text" value={triggerValue} onChange={(e) => {setTriggerValue(e.target.value)}} style={{"width": "50px"}} />
                                    <button className="button" style={{marginLeft: "10px"}} onClick={() => setAreaTriggerValue(controllerId, trigger.areaId, triggerValue)}>
                                        {props.t("allgemein.speichern")}
                                    </button>
                                </> 
                                : triggerValue
                            }</td>
                    </tr>
                    <tr>
                        <td>{props.t("elementeAllgemein.hysterese")} [%]</td>
                        <td>{
                            userCanEdit ? 
                                <>
                                    <input type="text" value={hysteresis} onChange={(e) => {setHysteresis(e.target.value)}} style={{"width": "50px"}} />
                                    <button className="button" style={{marginLeft: "10px"}} onClick={() => setAreaTriggerHysteresis(controllerId, trigger.areaId, hysteresis)}>
                                        {props.t("allgemein.speichern")}
                                    </button>
                                </>
                                : hysteresis
                        }</td>
                    </tr>
                </>
            )
        }

        return trigger.map((inputTrigger) => {
            switch (inputTrigger.$type) {
                case "lotreservationtrigger":
                    return (<LotReservationTrigger trigger={inputTrigger} />)
                case "areatrigger":
                    return (<AreaTrigger trigger={inputTrigger} controllerId={controllerId} />)
                default:
                    return (
                        <tr>
                            <td colspan={2}>{JSON.stringify(inputTrigger)}</td>
                        </tr>
                    )
            }
        });

    }
    
    return (
        <div className="pagewrapper-2">
            <div className="left-container-se left-part-carfinder" >

                {stateController.map((controller) => (
                    <div className="einstellungen-box" style={{ width: "30%", margin: "10px", marginBottom: "30px" }}>
                        <div className="box-name">
                            {controller.name}
                        </div>
                        <div style={{ overflow: "auto" }}>
                            <table style={{ "width": "100%" }}>
                                <tbody>
                                    <tr>
                                        <td>{props.t("stateControllerService.activated")}</td>
                                        <td>{controller.outputsActive === true ? props.t("allgemein.ja") : props.t("allgemein.nein")}</td>
                                    </tr>
                                    <TriggerRows trigger={controller.inputTriggerModels} controllerId={controller.id} />
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default withNamespaces()(StateControllerService)
